import { z } from 'zod';

import { defineCommand } from '@nesso/common-contracts/define';
import { metadata } from '@nesso/common-contracts/schema-metadata';

import { practiceIdSchema, practiceLocationIdSchema } from './ids';
import {
    businessEmailSchema,
    businessPhoneSchema,
    practiceLocationDetailsSchema,
    practiceNameSchema,
    taxIdSchema,
} from './practice.models';

export const PRACTICE_DELETE_TYPE = 'practice/delete';
export const PRACTICE_DELETE_EXPIRED_TYPE = 'practice/delete-expired';

export const practiceDelete = defineCommand(
    PRACTICE_DELETE_TYPE,
    z.object({
        practiceId: z.uuid(),
    }),
);

export const practiceDeleteExpired = defineCommand(PRACTICE_DELETE_EXPIRED_TYPE, z.object({}));

export const PRACTICE_UPDATE_TYPE = 'practice/update';

// No top-level `id` (the aggregate isn't named by one on this command), so `practiceId` itself
// carries the recordId tag.
export const practiceUpdate = defineCommand(
    PRACTICE_UPDATE_TYPE,
    z
        .object({
            practiceId: practiceIdSchema.meta(metadata.recordId),
            name: practiceNameSchema.optional(),
            businessEmail: businessEmailSchema.optional(),
            businessPhone: businessPhoneSchema.nullable().optional(),
            taxId: taxIdSchema.optional(),
        })
        .refine(
            (input) =>
                input.name !== undefined ||
                input.businessEmail !== undefined ||
                input.businessPhone !== undefined ||
                input.taxId !== undefined,
            'At least one field must be provided',
        ),
);

export const PRACTICE_ADD_LOCATION_TYPE = 'practice/add-location';

export const practiceAddLocation = defineCommand(
    PRACTICE_ADD_LOCATION_TYPE,
    practiceLocationDetailsSchema.extend({
        practiceId: practiceIdSchema.meta(metadata.nonSensitive),
    }),
    z.object({ id: practiceLocationIdSchema.meta(metadata.nonSensitive) }),
);

export const PRACTICE_UPDATE_LOCATION_TYPE = 'practice/update-location';

export const practiceUpdateLocation = defineCommand(
    PRACTICE_UPDATE_LOCATION_TYPE,
    practiceLocationDetailsSchema.extend({
        practiceId: practiceIdSchema.meta(metadata.nonSensitive),
        locationId: practiceLocationIdSchema.meta(metadata.recordId),
    }),
);

export const PRACTICE_REMOVE_LOCATION_TYPE = 'practice/remove-location';

export const practiceRemoveLocation = defineCommand(
    PRACTICE_REMOVE_LOCATION_TYPE,
    z.object({
        practiceId: practiceIdSchema.meta(metadata.nonSensitive),
        locationId: practiceLocationIdSchema.meta(metadata.recordId),
    }),
);

export const PRACTICE_SET_DEFAULT_LOCATION_TYPE = 'practice/set-default-location';

export const practiceSetDefaultLocation = defineCommand(
    PRACTICE_SET_DEFAULT_LOCATION_TYPE,
    z.object({
        practiceId: practiceIdSchema.meta(metadata.nonSensitive),
        locationId: practiceLocationIdSchema.meta(metadata.recordId),
    }),
);
